<div id="container-home-page">
  <div class="card card-home-page-white text-black">
    <div class="container">
      <div class="row mtb-50">
        <div class="col-md-12">
          <h1 class="card-title mt-50 text-center mb-5">
            TSOLife Software License Agreement
          </h1>

          <h2 class="mt-50">1. The Company’s Responsibilities</h2>
          <p class="mb-0">Last Updated 7/19/2018</p>

          <br />
          <p class="card-text mt-4">
            1.1 Services Commitment. The Company will: (i) make its cloud-based
            electronic legacy preservation services (the “Services”), as ordered
            by Customer pursuant to a Quote/Order Form which shall be deemed
            part of and subject to this MSA, available to Customer and
            Customer’s Users; (ii) make available “for fee” consulting and
            professional services as set out in separate PS Quotes/Order Forms
            and governed by the Company’s Professional Services Addendum
            attached to this MSA as Schedule 1; and (iii) provide the Services
            in accordance with applicable laws and government regulations.
            “Users” means individuals who are authorized by Customer to use and
            access the Services and who have been supplied user identifications
            and passwords. Users may include, but are not limited to, Customer’s
            employees, consultants, contractors, and agents, including qualified
            medical professionals, as determined and monitored by Customer.<br /><br />

            1.2 Subscription. Customer acknowledges the minimum term of a
            subscription is one month, during which Customer cannot cancel its
            subscription, following which the subscription will automatically
            renew for successive periods of one (1) month.<br /><br />

            1.3 Mobile Applications. Customer may pursuant to a Quote/Order Form
            order the Company’s mobile applications, which may be downloaded,
            installed and used on Users’ mobile devices. Customer acknowledges
            mobile applications require Users’ agreement to an end user license
            agreement in order to download, install and use such
            applications.<br /><br />

            1.4 Customer’s Resident Electronic Health Data. In the event that
            the Company has access to the health records of the Customer’s
            residents, the Company will: (i) maintain appropriate
            administrative, physical, and technical safeguards for the
            protection of the security, confidentiality and integrity of the
            electronic health records of Customer’s residents and other
            information which would be considered “Protected Health Information”
            or any similar descriptor (“Resident Record Data“) pursuant to the
            Health Insurance Portability and Accountability Act of 1996 (“HIPAA”
            and any amendments or implementing regulations), any more
            restrictive state law or any similar provincial law; (ii) obtain
            third-party audits which indicate whether the protection and
            security of Customer’s Resident Record Data meet established
            industry standards for the provision of services comparable to the
            Services; and (iii) unless otherwise specified, host Customer’s
            Resident Record Data in the United States. Details of the Company’s
            data access rights and obligations are set out in the BAA
            (applicability and definition below) and the Company’s Privacy
            Policy.
          </p>

          <h2 class="mt-50">2. Customer’s Use of the Services</h2>
          <br />
          <p class="card-text">
            2.1 Customer’s Responsibilities. Customer is solely responsible for:
            (i) Customer’s and Customers’ Users’ compliance with this MSA and
            all applicable schedules and addenda; (ii) managing Customer’s
            Users' identity and password combinations for use of and access to
            the Services; (iii) using commercially reasonable efforts to prevent
            password theft or loss, or unauthorized access to or use of the
            Services; (iv) notifying the Company promptly of any password theft,
            security breach or other unauthorized access to or use of the
            Services; (v) using the Services only in accordance with any
            documentation provided by the Company and all applicable local,
            state or provincial, federal, and/or international laws, rules and
            government regulations relating to Customer’s and Customers’ Users’
            use of the Services and Customer’s provision of health care and
            medical services to Customer’s residents; (vi) procuring and
            maintaining the network connections which allow Customer’s Users to
            access and use the Services; and (vii) ensuring Customer’s Users
            follow login procedures which support such protocols.<br /><br />

            2.2 Prohibited Actions. Customer shall not: (i) make the Services
            available to anyone other than Users; (ii) sell, resell, lease,
            timeshare or transfer the Services except as set forth in Sections
            5.1; (iii) use the Services to upload, post, distribute, link to,
            publish, reproduce, engage in, disseminate, or transmit any of the
            following: (a) malicious code, (b) illegal, fraudulent, libelous,
            defamatory, obscene, pornographic, profane, threatening, abusive,
            hateful, harassing, offensive, inappropriate, or objectionable
            information or communications, (c) content or data which would
            falsely represent Customer’s or any User’s or any resident’s
            identity, (d) content or data which constitutes a breach of any
            individual’s privacy, (e) advertisements or any other unsolicited
            communications, or (f) any information, software, or content which
            is not legally Customer’s and may be protected by copyright or other
            proprietary rights, or derivative works, without permission from the
            copyright owner or intellectual property rights owner; (iv)
            interfere with or disrupt the integrity or performance of the
            Services or third party data; (v) attempt to gain access to any
            other entity’s Services, or systems, networks, or related data which
            Customer does not have a legal right to access; (vi) copy,
            duplicate, reproduce, frame, or mirror any part of the Services,
            other than copying or framing on Customer’s own intranets or
            otherwise for Customer’s own internal business purposes; (vii)
            de-construct or reverse engineer the Services; (viii) access the
            Services if Customer has a business interest in, is creating or
            developing, or is planning the creation or development of, a legacy
            preservation technology service, product, or system in any way
            competitive with the Services; (ix) copy any features, functions, or
            graphics of the Services; or (x) access the Services for the purpose
            of monitoring availability, performance, functionality, or for any
            other benchmarking or competitive purpose.<br /><br />

            2.3 Beta Services. From time to time the Company may invite Customer
            to access and use services not generally available (“Beta
            Services”). Customer may accept or decline any such trial in
            Customer’s sole discretion. Beta Services shall be designated
            clearly as beta, pilot, limited release, developer preview,
            non-production, evaluation or by a description of similar import.
            The Company may discontinue Beta Services at any time in its sole
            discretion and may never make them generally available. The Company
            shall have no liability for any harm or damage arising out of or in
            connection with a Beta Service.<br /><br />
          </p>

          <h2 class="mt-50">3. Third Party Products</h2>
          <br />
          <p class="card-text">
            3.1 Embedded Technology. The Company may license technology from a
            third party and embed it within its Services. Customer consents to
            the use of Embedded Technology within the Services. In order to
            subscribe to use certain Embedded Technology, Customer may be
            required to agree to additional terms and conditions specific to
            that Embedded Technology. If the functions of Embedded Technology
            require a third party to access protected health information
            (“PHI”), the Company requires the Embedded Technology provider to
            enter into a business associate agreement (“BAA”).<br /><br />
          </p>

          <h2 class="mt-50">4. Fees and Payments</h2>
          <br />
          <p class="card-text">
            4.1 Fees. Customer shall pay all fees specified in Order Forms and
            associated invoices. Except as otherwise specified in an Order Form:
            (i) fees are based on the Services as set out in the Order Form for
            the Resident Capacities specified and not based upon actual usage of
            any particular application or by any particular facility; and (ii)
            payment obligations are non-cancelable and fees paid are
            non-refundable. Fees specified in an Order Form shall be effective
            for one year after the Effective Date, following which the Company
            may increase fees no more frequently than once annually upon sixty
            (60) days’ notice to Customer. Each Order Form shall expire and
            terminate on the date that is one year after the date of the Order
            Form if the Services ordered therein have not been activated and
            Customer will be issued a new Quote/Order Form for the Services at
            the then-applicable price.<br /><br />

            4.2 Resident Capacity. Unless otherwise specified, Prices presented
            in an Order Form are calculated with reference to Customer’s
            published licensed bed count (“Resident Capacity”). Customer shall
            promptly notify the Company by email addressed to
            'support@tsolife.com' of any increases in Customer’s Resident
            Capacity and shall pay all adjusted fees as calculated by the
            Company. Customer shall annually or upon request provide the Company
            with a copy of state- or provincially- issued documents setting
            forth Customer’s Resident Capacity. If Customer’s actual Resident
            Capacity exceeds the Resident Capacity it has reported to the
            Company, Customer shall pay all charges in arrears and adjusted
            subscription fees during the remainder of the Term resulting from
            such unreported increase. Decreases in Resident Capacity shall be
            similarly reported to the Company and shall entitle Customer to a
            decrease in fees payable following the date such decrease is
            reported. The Company shall maintain, at no charge, records of
            Customer’s residents who have been discharged or added to a waiting
            list.<br /><br />

            4.3 Transferred Facilities. Where Customer proposes to sell or
            otherwise transfer one or more facilities or all or substantially
            all of the assets of such facilities (each, a “Transfer”), Customer
            agrees to provide the Company with a minimum of thirty (30) days’
            written notice of any such proposed Transfer (whether or not such
            Transfer purports to include an assignment of this MSA). Customer
            agrees to inform the proposed buyer of this MSA and any overdue
            amounts hereunder, and to pay any such overdue amounts in full prior
            to completing the Transfer. Customer acknowledges and agrees that
            the failure to notify the Company of a Transfer and pay all overdue
            amounts shall be deemed to be fraud and a breach of this MSA and
            Customer shall be liable for all damages, including overdue amounts
            (which shall automatically be converted into a lien), the Company’s
            attorney fees, and any and all costs to enforce this Section 4.3
            together with any other damages that may be collectible under the
            law. If the buyer in a Transfer intends to continue to access and
            use the Services, Customer shall provide the Company with written
            authorization for the transfer of Data, including its Resident
            Record Data, to the buyer. Customer agrees that the Company’s
            provision of transition services may be billable including in
            connection with the transfer of ownership of one or more of
            Customer’s facilities. If Customer is the buyer in a Transfer: (i)
            Customer agrees to assume and pay any overdue amounts in respect of
            the transferred facilities; and (ii) if Customer requests a transfer
            Data in respect of the transferred facilities, Customer agrees to
            waive any right to, or claim of, successor liability as a defense to
            or release from liability of any amounts then due and owing to the
            Company by the seller at the time of the Transfer, and further that
            the receipt of such Data from the Company will be deemed a mere
            continuation, de facto merger and/or continuation of enterprise.<br /><br />

            4.4 Invoicing and Payment. The Company shall invoice Customer in
            accordance with the relevant Quote/Order Form. Unless otherwise
            stated in the Quote/Order Form, invoiced charges are due thirty (30)
            days from the invoice date. Customer is responsible for providing
            complete and accurate billing and contact information and notifying
            the Company of any changes to such information.<br /><br />

            4.5 Overdue Charges. The Company may charge interest on overdue
            amounts at the rate set out in the relevant invoice. Customer
            acknowledges and agrees that the Company may register a security
            interest in any amount that is overdue by 60 days or more and
            covenants to do, execute and deliver all such things, documents,
            agreements and assurances requested by the Company to such security
            is valid, enforceable and perfected. If Customer has failed to pay
            any amounts when due, the Company may suspend the Company’s
            provision of the Services to Customer, and may, upon reasonable
            notice, terminate this MSA for cause and cease its provision of the
            Services. The notice of termination will set out the processes,
            procedures and formats by which Customer’s Data will be made
            available to Customer.<br /><br />

            4.6 Fee Disputes. If Customer reasonably and in good faith disputes
            any fees, Customer must provide the Company with written notice of
            such dispute within ninety (90) days of the applicable invoice date,
            after which period Customer’s right of dispute expires. Customer
            must cooperate diligently with the Company to resolve the dispute
            and pay all undisputed fees when due. The Company will not exercise
            its rights under Section 4.5 in connection with fees disputed
            pursuant to this Section 4.6.<br /><br />

            4.7 Taxes. All quoted prices exclude federal and state or provincial
            sales, excise, use, goods and services, and value added or similar
            taxes (“Taxes”). Customer acknowledges it shall be responsible for
            the payment of any such Taxes to the Company (other than those based
            on the Company’s net income) unless it provides a valid tax
            exemption certificate or direct pay permit acceptable to taxing
            authorities. In the event the Company is assessed Taxes, interest
            and penalty by any taxing authority, Customer agrees to reimburse
            the Company for any such Taxes, including any interest or penalty
            assessed thereon.<br /><br />
          </p>

          <h2 class="mt-50">5. Data and Proprietary Rights</h2>
          <br />
          <p class="card-text">
            5.1 Customer’s Right to Use and Access the Services. The Company
            grants Customer a limited, non-exclusive, non-transferable (except
            pursuant to this Section 5.1) right to access and use, and permit
            Customer’s Users to access and use the Services during the Term.
            Subject to the limited rights granted to Customer under this MSA,
            the Company reserves all rights, title and interest in and to the
            Services, including all related intellectual property rights to the
            underlying software and any third party products and Integrated
            Services.<br /><br />

            5.2 Ownership of Customer’s Data and License by Customer to Host
            Customer’s Data. Except as provided in this MSA, Customer
            acknowledge and agrees that the Company: (i) owns the Customer’s
            Data and any intellectual property rights therein (excluding any
            PHI) and (ii) the Customer shall acquire no right, title, or
            interest in the Company’s display of such Data. Any PHI will remain
            the property of the patient and will be kept in a HIPAA and HITECH
            compliant manner and will only be provided in a HIPAA compliant
            manner.<br /><br />

            5.3 Suggestions. Customer grants the Company a royalty-free,
            worldwide, irrevocable, and perpetual license to use and incorporate
            into the Services any suggestions, enhancement requests,
            recommendations, or other feedback relating to the Services provided
            by Customer and Customer’s Users.<br /><br />
          </p>

          <h2 class="mt-50">6. Confidentiality</h2>
          <br />
          <p class="card-text">
            6.1 Definition of Confidential Information. "Confidential
            Information" means all confidential information disclosed by a party
            to the other party, whether orally or in writing, which is
            designated as confidential or which reasonably should be understood
            to be confidential given the nature of the information and the
            circumstances of disclosure. Confidential Information includes
            Customer’s Data, the terms and conditions of all Quotes/Order Forms,
            business and marketing plans, technology and technical information,
            product plans and designs, and business processes. Confidential
            Information (other than Resident Record Data) does not include any
            information which: (i) is or becomes generally known to the public
            without breach of any obligation owed to either party; (ii) was
            known to the receiving party prior to its disclosure without breach
            of any obligation owed to either party; (iii) is received from a
            third party without breach of any obligation owed to either party;
            or (iv) was independently developed by the receiving party. Customer
            may discuss with another party, in general terms, the types of
            services the Company provides and Customer’s opinion of the
            Company’s provision of these services.<br /><br />

            6.2 Protection of Confidential Information. The receiving party
            shall use the same degree of care to protect Confidential
            Information which it uses to protect the confidentiality of its own
            confidential information of like kind (but in no event less than
            reasonable care) and shall: (i) not use any Confidential Information
            for any purpose outside the scope of this MSA; and (ii) limit access
            to Confidential Information to those of its and its affiliates'
            employees, contractors and agents who need such access for purposes
            consistent with this MSA and who have signed confidentiality
            agreements with the receiving party containing protections no less
            stringent than those set forth in this MSA. Unless legally compelled
            to do so, neither party shall disclose the other party’s
            Confidential Information to any third party (other than its
            affiliates, contractors, agents and their respective legal counsel)
            without the other party's prior written consent.<br /><br />

            6.3 Confidentiality of the Company’s Services. Despite any other
            provision of this MSA, the Customer acknowledges that the software,
            processes and systems, including but not limited to the database
            schema, layout of screens, underlying business process and
            integrations that enable the Services embody valuable trade secrets
            proprietary to the Company. Therefore, the Customer shall take
            reasonable measures to protect the software and the systems from
            unauthorized access. The Customer will not provide access to the
            Services accept as provided pursuant to this MSA nor shall it
            disassemble or decompile the software that enable the Services for
            any purpose.<br /><br />

            6.4 Injunctive Relief. The parties agree that any breach of any
            provision of this MSA regarding confidentiality or protection of the
            Company’s proprietary rights would constitute irreparable harm and
            that the Company will be entitled to specific performance and/or
            injunctive relief in addition to other remedies at law or in
            equity.<br /><br />
          </p>

          <h2 class="mt-50">7. Warranties, Acknowledgments and Disclaimers</h2>
          <br />
          <p class="card-text">
            7.1 Customer’s Warranties. Customer warrants that: (i) it has
            validly entered into this MSA and has the legal power to do so; and
            (ii) its subscription for the Services is neither contingent upon
            the delivery of any future functionality or features nor dependent
            on any oral or written comments made by the Company regarding any
            future functionality or features.<br /><br />

            7.2 Customer’s Acknowledgments. Customer understands, acknowledges
            and agrees that: (i) the Company has made no representations or
            warranties that use of the Services will ensure Customer’s
            compliance with all applicable laws, rules, and regulations and that
            the Company does not warrant compliance with such laws, rules, and
            regulations through Customer’s use of the Services; (ii) Customer
            assumes all risks associated with Customer’s use of the Services in
            relation to applicable laws, rules, and regulations; (iii) the
            Services may not be appropriate or available for use in all
            countries; (iv) Customer is prohibited from accessing materials from
            countries or states where the contents of such materials are
            illegal; (v) Customer accepts all updates to the Services, including
            tools, utilities, improvements, or general updates to improve and
            enhance the features and performance of the Services; (vi) the
            Services are cloud-based services intended to deliver non- critical,
            non-emergency services; (vii) the Services are dependent on a number
            of factors beyond the Company’s control, including but not limited
            to, the operation of hardware and network services provided by third
            parties; (viii) the Services are not a substitute for any medical
            facility’s current systems of administering and safeguarding medical
            treatment and/or medicine; (ix) there may be occasional
            communication failures or delays in the delivery or receipt of
            properly sent communications which are beyond the Company’s control;
            and (x) Customer does not expect the Services to perform at the same
            level of performance and/or reliability reasonably expected from
            medical devices used in the delivery of critical medical care.<br /><br />

            7.3 Warranties. The Company warrants that: (i) it has validly
            entered into this MSA and has the legal power to do so; (ii) the
            Services do not infringe or misappropriate the intellectual property
            rights of any third party; (iii) it is the owner of the Services and
            has procured the appropriate licenses so that Customer has the right
            to use any embedded third-party software; (iv) to the Company’s
            knowledge, there is no claim or proceeding, pending or threatened,
            alleging that any of the Company’s software or equipment infringes
            or misappropriates the intellectual property rights of any third
            party; (v) there is no outstanding litigation, arbitration, or other
            dispute to which the Company is a party which, if decided
            unfavorably to the Company, would reasonably be expected to have a
            material adverse effect on the Company’s ability to fulfill its
            obligations under this MSA; (vi) the Services are duly protected
            with “up-to-date” and commercially reasonable anti-virus and
            anti-intrusion security software to prevent bugs, viruses,
            interruptions, errors, theft, destruction, and corruption which
            would affect the Services; and (vii) the functionality of the
            Services shall not be decreased materially during the Term. The
            Company will use commercially reasonable efforts to achieve, in all
            material respects, the functionality described in any documentation
            the Company may provide and, if the Company is unable to achieve
            such functionality, Customer’s sole and exclusive remedy shall be to
            terminate such Services and the MSA.<br /><br />

            7.4 DISCLAIMER OF REPRESENTATIONS AND WARRANTIES. EXCEPT AS
            DESCRIBED IN THIS MSA, THE SERVICES ARE PROVIDED "AS IS" AND TO THE
            MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE COMPANY, THE
            COMPANY’S AFFILIATES AND THE COMPANY’S THIRD-PARTY SERVICE OR DATA
            PROVIDERS, LICENSORS, DISTRIBUTORS OR SUPPLIERS (COLLECTIVELY
            REFERRED TO AS, "SUPPLIERS") DISCLAIM ALL WARRANTIES, EXPRESS OR
            IMPLIED, INCLUDING ANY WARRANTY THAT THE SERVICES ARE FIT FOR A
            PARTICULAR PURPOSE AND ANY WARRANTIES RELATED TO TITLE,
            MERCHANTABILITY, DATA LOSS, NON-INTERFERENCE WITH OR
            NON-INFRINGEMENT OF ANY INTELLECTUAL PROPERTY RIGHTS, OR THE
            ACCURACY, RELIABILITY, QUALITY OR CONTENT IN OR LINKED TO THE
            SERVICES. THE COMPANY DOES NOT WARRANT ACCESS TO THE INTERNET OR TO
            ANY OTHER SERVICE, CONTENT, OR DATA TRANSMITTED THROUGH THE
            SERVICES. THE COMPANY AND ITS SUPPLIERS DISCLAIM ANY REPRESENTATIONS
            OR WARRANTIES THAT CUSTOMER’S USE OF THE SERVICES SHALL SATISFY OR
            ENSURE COMPLIANCE WITH ANY LEGAL OBLIGATIONS, INCLUDING STATUTES OR
            REGULATIONS. THIS DISCLAIMER APPLIES TO BUT IS NOT LIMITED TO: (I)
            HIPAA, INCLUSIVE OF THE PRIVACY, SECURITY, BREACH NOTIFICATION, AND
            ENFORCEMENT RULES AT 45 C.F.R. PARTS 160 AND 164; (II) THE HEALTH
            INFORMATION TECHNOLOGY FOR ECONOMIC AND CLINICAL HEALTH ACT (TITLE
            XIII OF THE AMERICAN RECOVERY AND REINVESTMENT ACT OF 2009) AND ANY
            AMENDMENTS OR IMPLEMENTING REGULATIONS; (III) THE GRAMM-LEACH-BLILEY
            ACT OF 1999; (IV) THE SARBANES-OXLEY ACT OF 2002; AND (V) OTHER
            APPLICABLE FEDERAL, PROVINCIAL (INCLUDING THE PERSONAL HEALTH
            INFORMATION PROTECTION ACT, 2004 IN ONTARIO) OR STATE STATUTES OR
            REGULATIONS. CUSTOMER HAS SOLE RESPONSIBILITY FOR ENSURING THAT
            CUSTOMER’S USE OF THE SERVICES IS IN ACCORDANCE WITH APPLICABLE
            LAW.<br /><br />
          </p>

          <h2 class="mt-50">8. Indemnities</h2>
          <br />
          <p class="card-text">
            8.1 Indemnification by the Company. The Company will indemnify,
            defend and hold harmless Customer against any claims, liabilities,
            demands, suits, actions, proceedings, fines, expenses, penalties,
            judgments, or costs (collectively, "Claims") made or brought against
            Customer by a third party alleging that Customer’s use of the
            Services as permitted under this MSA infringes or misappropriates
            the intellectual property rights of a third party (a "Claim Against
            Customer"). The Company will indemnify, defend, and hold harmless
            Customer against any and all resulting direct damages, attorneys’
            fees and costs finally awarded against Customer as a result of, and
            for amounts paid by Customer under, a court-approved settlement of a
            Claim Against Customer, provided that Customer must: (a) promptly
            give the Company written notice of the Claim Against Customer; (b)
            give the Company sole control of the defense and settlement of the
            Claim Against Customer (provided that the Company may not settle any
            Claim Against Customer unless the settlement unconditionally
            releases Customer of all liability); and (c) provide the Company all
            reasonable assistance, at the Company’s expense. In the event of a
            Claim Against Customer, or if the Company reasonably believes the
            Services may infringe or misappropriate the rights of any third
            party, the Company may in its discretion and at no cost to Customer:
            (i) modify the Services so that they no longer infringe or
            misappropriate, without breaching the Company’s warranties; (ii)
            obtain a license for Customer’s continued use of the Services in
            accordance with this MSA; or (iii) terminate this MSA in accordance
            with its termination provisions.<br /><br />

            8.2 Indemnification by Customer. Customer will indemnify, defend and
            hold harmless the Company, its affiliates, the Third Parties
            referred to in Section 3 and the suppliers contracted by the Company
            to deliver all or part of the Services (“Indemnitees”) against any
            Claims made or brought against an Indemnitee by a third party
            alleging personal injury, tort, medical malpractice, or other acts,
            errors, or omissions in the delivery of medical care or medical
            information or which otherwise arise out of, or are in any way
            connected with, Customer’s Data, Customer’s and Customer’s Users’
            access to or use of the Services, Customer’s or Customer’s Users’
            negligent or wrongful act(s), and/or Customer’s or Customer’s Users’
            violation of relevant and/or applicable law (a "Claim Against the
            Company"). Customer will indemnify, defend, and hold harmless the
            Indemnitees from and against any and all resulting losses, damages,
            expenses (including reasonable attorneys’ and expert fees), whether
            or not such Claims Against the Company were foreseeable provided
            that the Company must: (a) promptly give Customer written notice of
            the Claim Against the Company; (b) give Customer sole control of the
            defense and settlement of the Claim Against the Company (provided
            that Customer may not settle any Claim Against the Company unless
            the settlement unconditionally releases the Company of all
            liability); and (c) provide Customer all reasonable assistance, at
            Customer’s expense.<br /><br />

            8.3 Indemnity Exclusions. The indemnification obligations set forth
            in Section 8.1 do not apply to Claims to the extent that they arise
            from: (a) Customer’s use of the Services in violation of this MSA or
            applicable law; (b) Customer’s negligent acts or omissions; (c)
            Customer’s use of the Services after the Company notifies Customer
            to discontinue use because of an infringement claim; or (d)
            modifications to the Services or use of the Services in combination
            with any software, application or service not made or provided by
            the Company. The indemnification obligations set forth in Section
            8.2 do not apply to Claims to the extent Customer is prohibited by
            statute or regulation from providing them.<br /><br />

            8.4 Exclusive Remedy. This Section sets forth the indemnifying
            party's sole liability to, and the indemnified party's exclusive
            remedy against, the other party for any type of Claim described in
            this Section.<br /><br />
          </p>

          <h2 class="mt-50">9. Limitation of Liability</h2>
          <br />
          <p class="card-text">
            9.1 No Responsibility. The Company shall not assume responsibility
            for: (i) any compromise, loss, delay, alteration, or interception of
            Customer’s Data during the transmission of any Data across computer
            networks or telecommunication facilities (including but not limited
            to the internet) which are not owned or operated by the Company; or
            (ii) the reliability or performance of any connections, computer
            networks, or telecommunications facilities (including but not
            limited to the internet) which are not owned or operated by the
            Company.<br /><br />

            9.2 EXCLUSION OF DAMAGES. EXCEPT FOR INDEMNITIES AND OBLIGATIONS
            REGARDING CONFIDENTIAL INFORMATION EXPRESSLY PROVIDED BY THIS MSA,
            IN NO EVENT WILL EITHER PARTY BE LIABLE TO THE OTHER UNDER ANY
            THEORY INCLUDING CONTRACT AND TORT (INCLUDING NEGLIGENCE AND STRICT
            PRODUCTS LIABILITY) FOR ANY INDIRECT, SPECIAL OR INCIDENTAL, OR
            CONSEQUENTIAL DAMAGES, EVEN IF THE PARTY CAUSING THE DAMAGES HAS
            BEEN ADVISED OF THE POSSIBILITY OF THE DAMAGES. SOME JURISDICTIONS
            DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR
            CONSEQUENTIAL DAMAGES SO THE ABOVE LIMITATION MAY NOT APPLY.<br /><br />

            9.3 EXCEPTIONS. THE LIMITATIONS AND EXCLUSIONS OF LIABILITY SET
            FORTH IN SECTION 9.2 DO NOT APPLY TO: (A) INDEMNIFICATION
            OBLIGATIONS; (B) LIABILITY RESULTING FROM THE GROSS NEGLIGENCE,
            FRAUD, OR WILLFUL OR CRIMINAL MISCONDUCT OF A PARTY; OR (C) DAMAGES
            OCCASIONED BY IMPROPER OR WRONGFUL TERMINATION OF THIS MSA OR
            ABANDONMENT OF ALL OR SUBSTANTIALLY ALL OF THE WORK REQUIRED TO
            PERFORM THE SERVICES.<br /><br />

            9.4 LIABILITY CAP. Except for the Company’s indemnity expressly
            provided for by this MSA and the Company’s confidentiality
            obligations, in no event will the Company’s aggregate liability, if
            any, including liability arising out of contract, negligence, strict
            liability in tort or warranty, or otherwise, exceed the total amount
            of payments paid by the Customer to the Company pursuant to this MSA
            during the six (6) months immediately preceding the claim.<br /><br />
          </p>

          <h2 class="mt-50">10. Term and Termination</h2>
          <br />
          <p class="card-text">
            10.1 Term of the MSA. This MSA shall be effective for a period
            commencing on the date Customer signs it (the “Effective Date”) and
            continuing until all subscriptions and services purchased hereunder
            have expired or been terminated.<br /><br />

            10.2 Term of Subscriptions. The term of Customer’s subscription for
            the Services may be set forth in Customer’s Quote/Order Form (the
            “Initial Term”); otherwise the term of subscription shall be yearly
            with automatic renewals. After any Initial Term, Customer’s
            subscription for the Services shall automatically renew on a yearly
            basis unless otherwise terminated in accordance with this Section
            10.<br /><br />

            10.3 Termination for Cause. Either party may terminate this MSA for
            cause: (i) upon thirty (30) days’ prior written notice to the other
            party of a material breach, if such breach remains uncured at the
            expiration of such notice period; or (ii) if the other party becomes
            the subject of a petition in bankruptcy or any other proceeding
            relating to insolvency, receivership, liquidation, or assignment for
            the benefit of creditors.<br /><br />

            10.4 Termination for Convenience by Customer. For the first sixty
            (60) days of the Initial Term, the Customer may terminate this MSA
            by providing thirty (30) day'. After the Initial Term, Customer may
            terminate the MSA at any time by providing thirty (30) days’ prior
            written notice to the Company.<br /><br />

            10.5 Termination for Convenience by the Company. Except for any
            specified Initial Term, the Company may terminate the MSA at any
            time by providing Customer with ninety (90) days’ prior written
            notice.<br /><br />

            10.6 Effect of Termination. Upon termination of this MSA, all rights
            and obligations of the parties will automatically terminate except
            for those set forth in this Section 10.6 and Section 10.7, and the
            Company shall not have any liability for the cessation of the
            Services or Customer’s discontinued access to or use of the
            Services. Customer shall receive a refund of any prepaid fees for
            Services not yet rendered upon termination of this MSA. Upon the
            provision to Customer of this data, the Company shall have no
            obligation to maintain or provide Customer with any of Customer’s
            Data and may then, in accordance with applicable law, delete
            Customer’s PHI in the Company’s systems or otherwise in the
            Company’s possession or under its control. Termination of this MSA
            shall automatically trigger termination of Customer’s schedules and
            other addenda incorporated in the MSA by reference.<br /><br />

            10.7 Provisions Surviving Termination. Section 1.4 (The Company’s
            Protection of Customer’s Resident Record Data, with respect to any
            such PHI which remains in the Company’s possession), Section 4 (Fees
            and Payment), Section 5 (Data and Proprietary Rights), Section 6
            (Confidentiality), Section 7.4 (the Company’s Disclaimer of
            Representations and Warranties), Section 8 (Indemnities), Section 9
            (Limitation of Liability), Section 10.6 (Effect of Termination),
            Section 12 (Notices), and Section 13 (General Provisions) shall
            survive the termination or expiration of this MSA.<br /><br />
          </p>

          <h2 class="mt-50">11. Notices</h2>
          <br />
          <p class="card-text">
            11.1 Any notices required or permitted to be given under this MSA
            will be given in writing and will be delivered (i) in person, (ii)
            by certified mail postage prepaid, return receipt requested, or
            (iii) by commercial overnight courier that guarantees next day
            delivery and provides a receipt, and such notices will be addressed
            to the address of the party as designated by Customer on the
            Acceptance Page of this MSA, on any Quote/Order Form, or as provided
            in the BAA or via the Services.<br /><br />
          </p>

          <h2 class="mtb-50">12. General Provisions</h2>
          <br />
          <p class="card-text">
            12.1 Governing Law and Jurisdiction. This MSA shall be governed by
            the State of Florida and the federal laws of the United States of
            America without regard to its conflicts of laws provisions. To
            resolve any legal dispute arising from this MSA, Customer agrees to
            the exclusive jurisdiction of the State of Florida.<br /><br />

            12.2 Entire Agreement. This MSA, including all Order Forms,
            exhibits, schedules and addenda attached or incorporated by
            reference, constitutes the entire agreement between Customer and the
            Company and supersedes all prior and contemporaneous agreements,
            proposals, or representations, whether written or oral, concerning
            its subject matter. However, to the extent of any conflict or
            inconsistency between the provisions in the body of this MSA and any
            exhibit, schedule, addendum or Order Form, the order of precedence
            shall be: (1) the applicable Quote/Order Form and any addenda
            thereto, (2) the applicable exhibit, schedule or addendum to this
            MSA, and (3) this MSA.<br /><br />

            12.3 Assignment. Neither party may assign any of its rights or
            obligations hereunder, whether by operation of law or otherwise,
            without the prior written consent of the other party (not to be
            unreasonably withheld).<br /><br />

            12.4 Counterparts. This MSA may be executed in one or more
            counterparts, including by way of facsimile, pdf or other electronic
            means, each of which shall be deemed to be an original, but all of
            which together shall constitute one and the same instrument.<br /><br />
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
